import { render, staticRenderFns } from "./GiftImageCell.vue?vue&type=template&id=78d27150&"
import script from "./GiftImageCell.vue?vue&type=script&lang=babel&"
export * from "./GiftImageCell.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports